/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelerDefs from './defs.defs.js'

const $nsid = 'app.bsky.labeler.getServices'

export { $nsid }

/** Get information about a list of labeler services. */
const main = l.query(
  $nsid,
  l.params({
    dids: l.array(l.string({ format: 'did' })),
    detailed: l.optional(l.withDefault(l.boolean(), false)),
  }),
  l.jsonPayload({
    views: l.array(
      l.typedUnion(
        [
          l.typedRef<LabelerDefs.LabelerView>(
            (() => LabelerDefs.labelerView) as any,
          ),
          l.typedRef<LabelerDefs.LabelerViewDetailed>(
            (() => LabelerDefs.labelerViewDetailed) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
